(() => {
  const routes = { sales: '/pages/pulse-mechanism', pdp: '/pages/pulse-direct', product: '/products/pulse' };
  const legacyRoutes = { sales: '/pages/pulse', pdp: '/products/pulse' };
  const marker = 'vessa_test';
  const getState = kind => {
    try { return JSON.parse(sessionStorage.getItem('vessa_mechanism_return:' + kind)); } catch { return null; }
  };
  const validReturn = (kind, state) => {
    try {
      const url = new URL(state.href, location.origin);
      const validPath = url.pathname === routes[kind] || (url.pathname === legacyRoutes[kind] && url.searchParams.get('view') === 'mechanism');
      if (url.origin !== location.origin || !validPath) return null;
      url.pathname = routes[kind];
      url.searchParams.delete('view');
      return url;
    } catch { return null; }
  };
  const kind = document.body.dataset.vessaTest;
  if (routes[kind]) {
    const saved = getState(kind);
    const navigation = performance.getEntriesByType('navigation')[0];
    const returning = location.hash === '#return' || ['reload', 'back_forward'].includes(navigation?.type);
    let restoring = returning && !!validReturn(kind, saved);
    let applyingSavedChoice = false;
    const remember = (force = false) => {
      if (restoring && !force) return;
      const selected = document.querySelector('.v-offer-form input[type="radio"][name="quantity"]:checked');
      const url = new URL(location.href);
      url.pathname = routes[kind];
      url.searchParams.delete('view');
      const state = { href: url.pathname + url.search, scroll: scrollY, quantity: Number(selected?.value || 1) };
      try {
        sessionStorage.setItem('vessa_mechanism_return:' + kind, JSON.stringify(state));
        sessionStorage.setItem('vessa_sales_return', state.href + '#return');
      } catch {}
    };
    const restore = (restoreQuantity = true) => {
      if (!restoring) return;
      if (restoreQuantity) {
        const input = [...document.querySelectorAll('.v-offer-form input[type="radio"][name="quantity"]')].find(el => Number(el.value) === saved.quantity);
        if (input && !input.disabled) {
          applyingSavedChoice = true;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          applyingSavedChoice = false;
        }
      }
      window.scrollTo({ top: Math.max(0, Number(saved.scroll) || 0), left: 0, behavior: 'instant' });
    };
    const completeRestore = () => {
      restore();
      // A late scroll correction must not overwrite a choice made after Back.
      setTimeout(() => { restore(false); restoring = false; remember(); }, 500);
    };
    if (restoring) history.scrollRestoration = 'manual';
    window.addEventListener('pageshow', completeRestore);
    if (document.readyState === 'complete') completeRestore();
    window.addEventListener('pagehide', () => remember(true));
    document.addEventListener('submit', () => remember(true), true);
    document.addEventListener('change', () => remember(!applyingSavedChoice));
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      if (url.pathname === '/cart' || url.pathname.startsWith('/policies/')) {
        url.searchParams.set(marker, kind);
        link.href = url.pathname + url.search + url.hash;
        link.addEventListener('click', () => remember(true));
      }
    });
    remember();
    return;
  }
  if (!(location.pathname === '/cart' || location.pathname.startsWith('/policies/'))) return;
  let context = new URLSearchParams(location.search).get(marker);
  // Shopify cart updates/removals can redirect to /cart without query parameters.
  // Recover only a validated, same-session source, including the original-page
  // check so the older sales page cannot inherit a stale mechanism/PDP context.
  if (!routes[context]) {
    try {
      const recent = new URL(sessionStorage.getItem('vessa_sales_return'), location.origin);
      if (recent.origin === location.origin) {
        context = Object.keys(routes).find(key => recent.pathname === routes[key] && validReturn(key, getState(key)));
      }
    } catch {}
  }
  if (!routes[context]) return;
  if (!new URLSearchParams(location.search).has(marker)) {
    const contextual = new URL(location.href);
    contextual.searchParams.set(marker, context);
    history.replaceState(history.state, '', contextual.pathname + contextual.search + contextual.hash);
  }
  const state = getState(context);
  const target = validReturn(context, state) || new URL(routes[context], location.origin);
  target.hash = 'return';
  const returnHref = target.pathname + target.search + target.hash;
  document.querySelectorAll('.v-policy-back a, [data-vessa-back]').forEach(link => { link.href = returnHref; });
  document.querySelectorAll('.v-cart-item a[href], .v-header a[href], .v-policy-links a[href]').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    if (url.pathname === '/products/pulse') { link.href = returnHref; return; }
    if (context === 'product' && link.closest('.v-header') && ['/', '/pages/pulse'].includes(url.pathname)) { link.href = returnHref; return; }
    if (url.pathname === '/cart/change') {
      url.searchParams.set('return_to', '/cart?' + marker + '=' + context);
      link.href = url.pathname + url.search;
      return;
    }
    if (url.pathname === '/cart' || url.pathname.startsWith('/policies/')) {
      url.searchParams.set(marker, context);
      link.href = url.pathname + url.search + url.hash;
    }
  });
  const cartForm = document.querySelector('#v-cart-form');
  if (cartForm) {
    const action = new URL(cartForm.action, location.origin);
    action.searchParams.set(marker, context);
    cartForm.action = action.pathname + action.search;
  }
})();
